<template>
  <div class="header">
    <header class="container">
      <div class="logo">
        <img src="../assets/home_logo.png" alt="" />
      </div>
      <ul>
        <li :class="active == 1 ? 'head-active' : ''" @click="skip(1)">首页</li>
        <li :class="active == 2 ? 'head-active' : ''" @click="skip(2)">APP</li>
        <li :class="active == 3 ? 'head-active' : ''" @click="skip(3)">优品</li>
        <li :class="active == 4 ? 'head-active' : ''" @click="skip(4)">
          品牌简介
        </li>
      </ul>
      <div class="phone">
        <div class="icon">
          <img src="../assets/home_call.png" alt="" />
        </div>
        400-991-8857
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "Head",
  data() {
    return {
      active: 1,
    };
  },
  methods: {
    skip(val) {
      if (val == 1) {
        this.$router.push({ name: "home" });
      } else if (val == 2) {
        this.$router.push({ name: "app" });
      } else if (val == 3) {
        this.$router.push({ name: "superior" });
      } else if (val == 4) {
        this.$router.push({ name: "introduction" });
      }
      this.active = val;
    },
  },
  created() {
    var path = this.$route.path;
    if (path == "/") {
      this.active = 1;
    } else if (path == "/app") {
      this.active = 2;
    } else if (path == "/superior") {
      this.active = 3;
    } else if (path == "/introduction") {
      this.active = 4;
    }
  },
};
</script>

<style lang="scss">
.header{
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  background-color: #fff;
  header {
  background-color: #fff;
  height: 79px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    width: 178px;
    height: 56px;
    margin-left: 99px;
  }

  ul {
    display: flex;
    margin-left: 73px;

    li {
      font-size: 21px;
      font-weight: 400;
      color: #000000;
      line-height: 34px;
      padding: 0 24px;
      cursor: pointer;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .head-active {
      color: #ff0d0d;
    }
  }

  .phone {
    font-size: 24px;
    font-weight: 600;
    color: #ff5e5e;
    line-height: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    display: flex;
    align-items: center;
    margin-right: 110px;

    .icon {
      width: 30px;
      height: 30px;
      margin-right: 14px;
    }
  }
}
}

</style>